import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CREATE_VALE_PEDAGIO_TAXA" }
);

export interface CreateValePedagioTaxaState extends IState {}

const INITIAL_STATE: CreateValePedagioTaxaState = {
  loading: false,
  error: null,
};

const request = (state: CreateValePedagioTaxaState) =>
  update(state, { loading: { $set: true }, error: { $set: null } });

const success = (state: CreateValePedagioTaxaState, action: ISuccessAction) =>
  update(state, { loading: { $set: false } });

const failure = (state: CreateValePedagioTaxaState, action: IFailureAction) =>
  update(state, { loading: { $set: false }, error: { $set: action.error } });

const reset = () => INITIAL_STATE;

export const createValePedagioTaxa = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreateValePedagioTaxaTypes = Types;
export const CreateValePedagioTaxaActions = Creators;